import { EdgeDevice } from "./edgeDeviceInterfaces";

const getWireguardTunnelLabel = (device: EdgeDevice) => {
  return device.tunnel?.tunnel_name ?? "";
};

export const applyEdgeDeviceSearch = (
  devices: EdgeDevice[],
  searchText: string
): EdgeDevice[] => {
  const normalizedSearch = searchText.trim().toLowerCase();
  if (!normalizedSearch) {
    return devices;
  }

  return devices.filter((device) => {
    const searchableValues = [
      device.serial_number,
      device.mac_address,
      device.manufacturer,
      device.sku,
      getWireguardTunnelLabel(device),
      device.provisioning_state,
    ];

    return searchableValues.some((value) =>
      String(value ?? "")
        .toLowerCase()
        .includes(normalizedSearch)
    );
  });
};

export const getEdgeDeviceWireguardTunnelLabel = getWireguardTunnelLabel;
